import axios from 'axios';


const API_URL = '/lyra_payment/';

class LyraService {
    async setPaidFreeCheckout(uuid) {
        if (!uuid) return false;
        const data = { "uuid": uuid };
        try {
            await axios.post(API_URL + 'free_checkout.php', data);
            return true;
        }
        catch (err) {
            return false;
        }
    }

    async setPaidFreeCheckoutChangementParcours(uuid) {
        if (!uuid) return false;
        const data = { "uuid": uuid };
        try {
            await axios.post(API_URL + 'free_checkout_changement_parcours.php', data);
            return true;
        }
        catch (err) {
            return false;
        }

    }

    async setPaidFreeCheckoutAmendOptions(id_amended) {
        if (!id_amended) return false;
        const data = { "id_amended": id_amended };
        try {
            let res = await axios.post(API_URL + 'amend_free_checkout.php', data);
            return res.data;
        }
        catch (err) {
            return false;
        }
    }
}

export default new LyraService();